import { request } from './request'

export const getClientDownLoadList = () => request('/portal/agentClient/clientDownloadList')

export interface GetClientHashData {
  id: number
}
export const getClientHash = (data: GetClientHashData) =>
  request('/portal/agentClient/clientDownloadHashList', {
    params: data,
  })

export const getClientList = () => request('/portal/agentClient/clientList')

export interface DeleteClientData {
  id: string
}
export const deleteClient = (data: DeleteClientData) =>
  request('/portal/agentClient/client', {
    method: 'delete',
    params: data,
  })
export interface UninstallClientData {
  id: number
}
export const uninstallClient = (data: UninstallClientData) =>
  request('/portal/agentClient/agent/uninstall', {
    method: 'delete',
    params: data,
    headers: {
      'Content-Type': 'application/json',
    },
  })

export interface EditClientRemark {
  id: number
  remark: string
}
export const editClientRemark = (data: EditClientRemark) =>
  request('/portal/agentClient/clientRemark', {
    method: 'put',
    data,
  })

export const getAgentKey = () => request('/portal/agentClient/agentKey')

export const resetAgentKey = () =>
  request('/portal/agentClient/generateKey', {
    method: 'post',
  })
// 自动更新
export interface ClientRemark {
  id: number
  remark: string
  auto: number
  change_area_id: number
  biz_id: number | string
  area_id: number | string
}
export const clientRemark = (params: ClientRemark) =>
  request('/portal/agentClient/agent/operate', {
    method: 'put',
    data: params,
  })
// 修改别名
export interface UpdateAlias {
  id: number
  alias: string
}
export const updateAlias = (data: UpdateAlias) =>
  request('/portal/agentClient/agent/updateAlias', {
    method: 'post',
    data,
  })

// 客户端
// 获取客户端列表
export interface Getagentlist {
  search: string
  conn_status?: number
}
export const getagentlist = (data: Getagentlist) =>
  request('/portal/agentClient/agent/list', {
    params: {
      ...data,
    },
  })

// 编辑客户端
export interface Putoperate {
  id: number
  remark?: string
  auto: number
  area_id: number
  change_area_id: number
  biz_id: number
  bandwidth_upstream?: number
  bandwidth_downstream?: number
}
export const putoperate = (data: Putoperate) =>
  request('/portal/agentClient/agent/operate', {
    method: 'put',
    data,
  })

// 获取所有安全域
export interface Getagentarea {}
export const getagentarea = (data: Getagentarea) =>
  request('/portal/agentClient/agent/area', {
    params: {
      ...data,
    },
  })

//获取安装包列表
export interface Getpackagelist {}
export const getpackagelist = (data: Getpackagelist) =>
  request('/portal/agentClient/package/list', {
    params: {
      ...data,
    },
  })

//获取安装包hash
export interface Getpackagehash {
  package_id: number
}
export const getpackagehash = (data: Getpackagehash) =>
  request('/portal/agentClient/package/hash', {
    params: {
      ...data,
    },
  })

// 下载客户端
// export interface Packagedownload {
//   package_id: number
//   name: string
// }
// export const packagedownload = (data: Packagedownload) =>
//   request('/portal/agentClient/package/download', {
//     method: 'post',
//     data: {
//       ...data,
//     },
//   })

export interface Packagedownload {
  package_id: number
  name: string
}
export const packagedownload = (data: Packagedownload) =>
  request('/portal/agentClient/package/download', {
    params: {
      ...data,
    },
  })
// 更新安全域
export interface Updatearea {
  id: string
  area_id: string
}
export const updatearea = (data: Updatearea) =>
  request('/portal/agentClient/agent/updateArea', {
    method: 'post',
    data,
  })
// 安全域
// 获取所有客户端/站点/邮箱
export interface Getmemberall {
  search?: string
  area_id?: string
}
export const getmemberall = (data: Getmemberall) =>
  request('/portal/agentClient/area/member/all', {
    params: {
      ...data,
    },
  })

// 获取安全域下所有绑定的成员
export interface Getmemberbind {
  search?: string
  area_id: number
}
export const getmemberbind = (data: Getmemberbind) =>
  request('/portal/agentClient/area/member/bind', {
    params: {
      ...data,
    },
  })

// 添加安全域
export interface AgentClientaddarea {
  name: string
  agent_area_id?: number[]
  email_area_id?: number[]
  site_area_id?: number[]
}
export const agentClientaddarea = (data: AgentClientaddarea) =>
  request('/portal/agentClient/area', {
    method: 'post',
    data: {
      ...data,
    },
  })

// 编辑安全域
export interface PutagentClientarea {
  id: string
  name: string
  agent_id?: string[]
  email_id?: string[]
  site_id?: string[]
}
export const putagentClientarea = (data: PutagentClientarea) =>
  request('/portal/agentClient/area', {
    method: 'put',
    data: {
      ...data,
    },
  })

// 删除安全域
export interface Deletearea {
  id: number[]
}
export const deletearea = (data: Deletearea) =>
  request('/portal/agentClient/area', {
    method: 'delete',
    data,
  })

// 添加安全域成员
export interface Addareamember {
  area_id: number
  agent_area_id?: number[]
  email_area_id?: number[]
  site_area_id?: number[]
}
export const addareamember = (data: Addareamember) =>
  request('/portal/agentClient/area/member', {
    method: 'post',
    data,
  })

// 获取安全域列表
export interface Getarea {
  search?: string
}
export const getarea = (data: Getarea) =>
  request('/portal/agentClient/area', {
    params: {
      ...data,
    },
  })

// 删除绑定关系
export interface Deleteareamember {
  agent_area_id?: string[]
  email_area_id?: string[]
  site_area_id?: string[]
}
export const deleteareamember = (data: Deleteareamember) =>
  request('/portal/agentClient/area/member', {
    method: 'delete',
    data,
  })

//获取ip地址
export const getIp = () => request('/portal/agentClient/package/clientCommunication')

// 批量删除客户端
export const batchDeleteClient = (data: any) =>
  request('/portal/v1/agent_client/batch_delete', {
    method: 'post',
    data,
  })

// 批量卸载客户端
export const batchUnloadClient = (data: any) =>
  request('/portal/v1/agent_client/batch_uninstall', {
    method: 'post',
    data,
  })

// 开始收集运行日志
export const logsCollectStart = (data: any) =>
  request('/portal/v1/agent_client/logs/collect/start', {
    method: 'post',
    data,
  })

// 停止收集运行日志
export const logsCollectStop = (data: any) =>
  request('/portal/v1/agent_client/logs/collect/stop', {
    method: 'post',
    data,
  })

// 更新日志存储时间
export const logsRetention = (data: any) =>
  request('/portal/v1/agent_client/logs/retention', {
    method: 'put',
    data,
  })

// 获取收集运行日志记录
export interface Record {
  agent_id: number
}
export const logsRecord = (data: Record) =>
  request('/portal/v1/agent_client/logs/record', {
    params: {
      ...data,
    },
  })

// 下载日志
export interface Download {
  agent_id: number
  log_id: string | number
}

export const logsDownload = (data: Download) =>
  request('/portal/agentClient/log/download', {
    params: data,
    responseType: 'blob',
    timeout: 1000 * 30,
  })

// 删除日志
export const logsDelete = (data: Download) =>
  request('/portal/v1/agent_client/logs/collect/delete', {
    method: 'post',
    data,
  })

// 验证环境管理列表
export const getEnvManagementList = (agentId: string) =>
  request(`/portal/v1/agent_client/${agentId}/dependency_env`)

// 启停客户端验证环境
export const startStopEnvManagement = (
  agentId: string,
  dependencyId: string,
  isAutoStart: boolean,
) =>
  request(`/portal/v1/agent_client/${agentId}/dependency_env/${dependencyId}`, {
    method: 'put',
    data: {
      isAutoStart,
    },
  })

/**
 * 生成Agent安装命令请求
 */
export interface GetDownloadParams {
  /**
   * 自动安装依赖环境
   */
  autoInstallDependEnvs?: boolean
  installMethod?: V1InstallMethod
  os?: V1AgentOs
  osArchitecture?: V1AgentOSArchitecture
  proxyInfo?: V1GenerateInstallCommandRequestProxy
  [property: string]: any
}

/**
 * 安装方式枚举，- ONE_CLICK: 一键安装
 * - TRADITIONAL: 安装包安装
 */
export enum V1InstallMethod {
  InstallMethodUnknown = 'INSTALL_METHOD_UNKNOWN',
  OneClick = 'ONE_CLICK',
  Traditional = 'TRADITIONAL',
}

/**
 * Agent安装命令生成相关定义
 * 平台枚举，- AGENT_OS_LINUX_RPM: AGENT_OS_WINDOWS_32BIT = 2; // 废弃
 * - AGENT_OS_LINUX_DEB: AGENT_OS_UOS = 5; // 废弃
 */
export enum V1AgentOs {
  AgentOSLinuxDeb = 'AGENT_OS_LINUX_DEB',
  AgentOSLinuxRPM = 'AGENT_OS_LINUX_RPM',
  AgentOSUnknown = 'AGENT_OS_UNKNOWN',
  AgentOSWindows64Bit = 'AGENT_OS_WINDOWS_64BIT',
}

/**
 * 平台架构枚举
 */
export enum V1AgentOSArchitecture {
  AgentOSArchitectureArm = 'AGENT_OS_ARCHITECTURE_ARM',
  AgentOSArchitectureUnknown = 'AGENT_OS_ARCHITECTURE_UNKNOWN',
  AgentOSArchitectureX86 = 'AGENT_OS_ARCHITECTURE_X86',
}

/**
 * v1GenerateInstallCommandRequestProxy
 */
export interface V1GenerateInstallCommandRequestProxy {
  /**
   * 代理地址
   */
  address?: string
  /**
   * 代理密码
   */
  password?: string
  protocol?: GenerateInstallCommandRequestProxyProtocol
  /**
   * 代理用户名
   */
  username?: string
  [property: string]: any
}

/**
 * 代理协议
 */
export enum GenerateInstallCommandRequestProxyProtocol {
  ProxyProtocolHTTP = 'PROXY_PROTOCOL_HTTP',
  ProxyProtocolHTTPS = 'PROXY_PROTOCOL_HTTPS',
  ProxyProtocolSocks5 = 'PROXY_PROTOCOL_SOCKS5',
  ProxyProtocolUnknown = 'PROXY_PROTOCOL_UNKNOWN',
}

// 获取下载参数
export const getDownloadParams = (data: GetDownloadParams) =>
  request('/portal/agentClient/agent/install_command', {
    method: 'post',
    data,
  })

// 获取agent需要的host和port信息
export const getAgentHostAndPort = () =>
  request('/portal/v1/agent_client/agent/need_host_and_port', {
    method: 'get',
  })
